interface OrderHeaderListType {
  label: string;
  activeState: number;
}

export const orderHeaderList: OrderHeaderListType[] = [
  {
    label: "Pending Orders",
    activeState: 0,
  },
  {
    label: "Completed Orders",
    activeState: 1,
  },
  {
    label: "Wishlist",
    activeState: 2,
  },
];

export const ORDER_CRM_STATE = {
  PENDING: 0,
  COMPLETED: 1,
  WISHLIST: 2,
};

export const COMMUNICATION_MODE = {
  SMS: 0,
  WHATSAPP: 1,
  EMAIL: 2,
};

export const REMINDER_CONSENT_TYPE = {
  LOW_STOCK: 2,
  OUT_STOCK: 0,
};

export const WISHLIST_CRM_MULTI_STATE = {
  NO_PRODUCT_STATE: 0,
  LOCK_STATE: 1,
  DISABLE_STATE: 2,
};
